import { Alert, Button } from '30pay/components';
import { Card } from 'utilities/components';
import { __BuyPaymentMethodProps, __BuyPaymentMethodsEnum } from './buyPaymentMethod.interface';
import { BuyPaymentMethods } from './buyPaymentMethod.data';
import { useEffect, useRef, useState } from 'react';
import BuyPaymentDirectMethod from './methods/direct/buyPaymentDirectMethod.index';
import BuyPaymentCardToCardMethod from './methods/cardToCard/cardToCard.index';
import { get, post } from 'scripts';
import { API } from 'data/30pay.api';
import { Popover, Radio, Spin } from 'antd';
import BuyPaymentCashInMethod from './methods/cashIn/cashIn.index';
import { OfflineDepositActivation, UUSDOrderResult, Wallet } from 'interfaces';
import BuyPaymentOfflineMethod from './methods/offline/offline.index';
import { __BuyWithdrawMethodsEnums } from '../buyWithdrawMethod/buyWithdrawMethod.interface';
import { getWallet } from '30pay/wallet/wallet.service';
import { WalletSummary } from '30pay/wallet/walletSummary/walletSummary';
import { HiArrowLeft, HiArrowRight } from 'react-icons/hi2';
import { ConvertBoxDataType } from '../convertBox.index';
import ConvertBoxConfirmOrderModal, {
    ConvertBoxConfirmOrderDetailModalRef,
} from '30pay/trade/convertBox/confirmOrderModal/orderDetailModal.index';
import { useNavigate } from 'react-router-dom';
import { ThankYouModal } from '30pay/components/thankYou/payment/modal/thankYouModal.index';
import { Link } from 'react-router-dom';
import { PATH } from 'data/30pay.path';

const BuyPaymentMethod: React.FC<__BuyPaymentMethodProps> = (props: __BuyPaymentMethodProps) => {
    const [selectedMethod, setSelectedMethod] = useState<__BuyPaymentMethodsEnum>(__BuyPaymentMethodsEnum.Wallet);
    const [stage, setStage] = useState<__BuyPaymentMethodsEnum>();

    const [confirmData, setConfirmData] = useState<ConvertBoxDataType>();

    const [data, setData] = useState(props.data);
    const [isCardToCardActive, setIsCardToCardActive] = useState<boolean>();
    const [isOfflineDepositActive, setIsOfflineDepositActive] = useState<boolean>();
    const [isCashIntActive, setIsCashIntActive] = useState<boolean>();

    const [wallet, setWallet] = useState<Wallet>();
    const [hideBalances, setHideBalances] = useState<boolean>(false);
    const [walletLoading, setWalletLoading] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const confirmOrderModalRef = useRef<ConvertBoxConfirmOrderDetailModalRef>(null);

    const [paymentUrl, setPaymentUrl] = useState<string>();
    const [thankYouModal, setThankYouModal] = useState<UUSDOrderResult>();
    const [isGatewayActive, setIsGatewayActive] = useState<boolean>();

    const navigate = useNavigate();

    useEffect(() => {
        get<{ isActive: boolean }>(API.siteSettings.gatewaySettingsActivation)
            .then((res) => setIsGatewayActive(res.value.value.isActive))
            .catch(() => setIsGatewayActive(false));
        getWallet(setWalletLoading, setWallet);
    }, []);

    function apiCallHandler() {
        confirmOrderModalRef.current?.startLoading();
        const { data } = props;
        const UUSDBody = {
            source: 0,
            platform: 1,
            amount: data?.srcValue,
            cardNumberId: data?.bankAccountId,
        };
        const CryptoBody = {
            ...UUSDBody,
            destinationSymbol: data?.destCoin?.symbol,
            walletAddress: data?.walletAddress,
            network: data?.network?.network,
        };
        const api = data?.destCoin?.symbol === 'UUSD' ? API.orderTransaction.buyUUSD : API.orderTransaction.buyCrypto;
        const body = data?.destCoin?.symbol === 'UUSD' ? UUSDBody : CryptoBody;
        post<UUSDOrderResult>(api, body)
            .then((res) => {
                // setConfirmData(undefined);
                if (res.value.value.paymentUrl) setPaymentUrl(res.value.value.paymentUrl);
                confirmOrderModalRef.current?.showResultContent(true, res.value.value.trackingCode, {
                    state: res.value.value.state,
                });
            })
            .catch((res) => confirmOrderModalRef.current?.showResultContent(false))
            .finally(() => confirmOrderModalRef.current?.stopLoading());
    }
    function submitHandler() {
        if (props.data?.destCoin?.symbol === 'UUSD') {
            if (selectedMethod === __BuyPaymentMethodsEnum.Gateway) {
                const output: ConvertBoxDataType = {
                    buyPaymentMethod: selectedMethod,
                };
                props.onSubmit(output);
            } else if (selectedMethod === __BuyPaymentMethodsEnum.Wallet) {
                setConfirmData(props.data);
            }
        } else {
            const output: ConvertBoxDataType = {
                buyPaymentMethod: selectedMethod,
            };
            props.onSubmit(output);
        }
    }

    function backHandler() {
        props.onBack();
    }

    return (
        <div className="flex max-lg:flex-col gap-6 h-full">
            <ConvertBoxConfirmOrderModal
                data={props.data}
                ref={confirmOrderModalRef}
                isOpen={!!confirmData}
                onClose={(needReFetch) => {
                    setConfirmData(undefined);
                    if (needReFetch) {
                        const output: ConvertBoxDataType = {
                            buyPaymentMethod: __BuyPaymentMethodsEnum.Other,
                        };
                        props.onSubmit(output);
                    }
                }}
                submitButton={{
                    title: paymentUrl ? 'انتقال به درگاه' : 'تایید سفارش',
                    onClick: () => {
                        if (paymentUrl) navigate(paymentUrl);
                        else apiCallHandler();
                    },
                }}
            />
            <Card className="flex-1" title="واریز ارز مبدا" titleDivider>
                {/* <div className="flex flex-col gap-6 -mt-6">
                    <div className="h-[50px] flex items-center px-8 gap-2  w-[calc(100%+48px)] -mr-6 border-b border-b-background">
                        {BuyPaymentMethods.map((item, index) => (
                            <div
                                key={index}
                                onClick={() => !determineIsLoading(item.key) && setStage(item.key)}
                                className={`max-w-[80px] flex-1 flex items-center justify-center h-full border-b-[4px] clickable !transition-all 
                                    ${item.key === stage ? 'text-black-100  border-b-primary-100' : 'text-black-60 border-b-[#00000000]'}
                                    ${determineIsDisabled(item.key) ? 'opacity-20 pointer-events-none cursor-not-allowed' : ''}
                                    `}
                            >
                                <Spin spinning={determineIsLoading(item.key)}>
                                    <label className="font-medium text-sm whitespace-nowrap clickable flex h-full items-center justify-center">
                                        {item.title}
                                    </label>
                                </Spin>
                            </div>
                        ))}
                    </div>
                    {stage === __BuyPaymentMethodsEnum.cardToCard && (
                        <BuyPaymentCardToCardMethod data={data} onBack={backHandler} />
                    )}
                    {stage === __BuyPaymentMethodsEnum.cashInDeposit && (
                        <BuyPaymentCashInMethod data={data} onBack={backHandler} />
                    )}
                    {stage === __BuyPaymentMethodsEnum.offlineDeposit && (
                        <BuyPaymentOfflineMethod data={data} onBack={backHandler} />
                    )}
                </div> */}
                {stage === __BuyPaymentMethodsEnum.Gateway && (
                    <BuyPaymentDirectMethod data={data} onBack={backHandler} />
                )}
                {stage === undefined && (
                    <>
                        <div className="flex">
                            <Radio.Group
                                style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}
                                buttonStyle="solid"
                                onChange={(e) => setSelectedMethod(e.target.value)}
                                value={selectedMethod}
                            >
                                <Spin spinning={isGatewayActive === undefined}>
                                    <Radio
                                        disabled={!isGatewayActive}
                                        value={__BuyPaymentMethodsEnum.Gateway}
                                        className="text-base max-lg:text-sm"
                                    >
                                        درگاه پرداخت
                                    </Radio>
                                </Spin>
                                <Spin spinning={walletLoading}>
                                    <Popover
                                        placement="bottomRight"
                                        trigger={'hover'}
                                        content={
                                            <div className="flex flex-col gap-2">
                                                <p className="flex items-center gap-2">
                                                    <span className={'rounded-full w-2 h-2 bg-primary-100'}></span>
                                                    <span className={'text-darkPurple-100 text-xs font-bold'}>
                                                        موجودی فعلی
                                                    </span>
                                                </p>
                                                <p className="flex items-center gap-1">
                                                    <span className="text-base text-darkPurple-100 font-bold">
                                                        {wallet?.assets
                                                            ?.find((asset) => asset.symbol?.toUpperCase() === 'IRT')
                                                            ?.available.toLocaleString()}
                                                    </span>
                                                    <span className="text-sm text-darkPurple-100 font-bold">تومان</span>
                                                </p>
                                            </div>
                                        }
                                    >
                                        <Radio
                                            value={__BuyPaymentMethodsEnum.Wallet}
                                            className="text-base max-lg:text-sm"
                                        >
                                            <div className="flex items-center gap-1">
                                                <p>کیف پول</p>
                                                <Link className="text-primary-100 text-sm" to={PATH.wallet}>
                                                    (افزایش موجودی)
                                                </Link>
                                            </div>
                                        </Radio>
                                    </Popover>
                                </Spin>
                            </Radio.Group>
                        </div>
                        <div className="flex items-center w-full gap-4 mt-6">
                            <Button
                                disabled={isGatewayActive === undefined || walletLoading}
                                onClick={submitHandler}
                                loading={loading}
                                className="w-full h-16"
                                type="primary"
                            >
                                <HiArrowRight />
                                ادامه
                            </Button>
                            <Button onClick={props.onBack} className="w-full h-16 bg-background" type="text">
                                بازگشت
                                <HiArrowLeft />
                            </Button>
                        </div>
                    </>
                )}
            </Card>
            <div className={'flex flex-1 flex-col'}>
                <Spin spinning={walletLoading}>
                    <WalletSummary {...{ wallet, hideBalances, setHideBalances }} />
                </Spin>
                <div className={'flex flex-col gap-6 mt-6'}>
                    <Alert
                        variant="info"
                        message={
                            <>
                                <p className="text-sm text-black-100 font-bold">روش شارژ کیف پول:</p>
                                <p className="text-sm text-black-100 font-medium">
                                    در این روش پس از پرداخت، ارز به صورت خودکار به کیف پول موجود در پنل کاربری شما اضافه
                                    خواهد شد.
                                </p>
                            </>
                        }
                    />
                    <Alert
                        variant="info"
                        message={
                            <>
                                <p className="text-sm text-black-100 font-bold">روش شارژ مستقیم:</p>
                                <p className="text-sm text-black-100 font-medium">
                                    این روش پس از وارد کردن لینک کیف پول رمزارز خود،ارز مقصد را دریافت می کنید.
                                </p>
                            </>
                        }
                    />
                </div>
            </div>
        </div>
    );
};
export default BuyPaymentMethod;
